import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { ILocation } from 'shared/types/location';

const ID = 'withNeighbors' as const;

export const withNeighborsTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery, location }) => {
    const withNeighbors = getTermValue('with_neighbors')(jsonQuery);

    if (withNeighbors === null) {
      return null;
    }

    const { displayName } = location as ILocation;
    const label = `${displayName} + 20км`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['windows_type'])(jsonQuery),
};
